import { z } from "zod";
import { integrationScopeSchema } from "./integration.js";
export const taxMcpToolNameSchema = z.enum([
    "tax_current_ruleset",
    "tax_lookup_rules",
    "tax_ncm_catalog",
    "tax_calculate_batch",
    "tax_get_calculation",
]);
export const taxMcpToolSchema = z
    .object({
    name: taxMcpToolNameSchema,
    method: z.enum(["GET", "POST"]),
    path: z.string().min(1),
    scope: integrationScopeSchema,
})
    .strict();
export const taxMcpRpcSchema = z
    .object({
    method: z.literal("POST"),
    path: z.literal("/v1/mcp"),
})
    .strict();
export const taxMcpCatalogSchema = z
    .object({
    schemaVersion: z.literal("1.0.0"),
    authHeader: z.literal("X-Tax-Api-Key"),
    rpc: taxMcpRpcSchema,
    tools: z.array(taxMcpToolSchema).min(1),
})
    .strict();
/**
 * Machine-readable MCP catalog for the five consumer operations.
 * Humans manage keys over Cognito. AI clients call POST /v1/mcp with X-Tax-Api-Key.
 */
export const TAX_MCP_CATALOG = {
    schemaVersion: "1.0.0",
    authHeader: "X-Tax-Api-Key",
    rpc: { method: "POST", path: "/v1/mcp" },
    tools: [
        {
            name: "tax_current_ruleset",
            method: "GET",
            path: "/v1/integrations/rulesets/current",
            scope: "READ_RULES",
        },
        {
            name: "tax_lookup_rules",
            method: "GET",
            path: "/v1/integrations/rules",
            scope: "READ_RULES",
        },
        {
            name: "tax_ncm_catalog",
            method: "GET",
            path: "/v1/integrations/ncm-catalog",
            scope: "READ_NCM_CATALOG",
        },
        {
            name: "tax_calculate_batch",
            method: "POST",
            path: "/v1/integrations/calculations:batch",
            scope: "CALCULATE",
        },
        {
            name: "tax_get_calculation",
            method: "GET",
            path: "/v1/integrations/calculations/{calculationId}",
            scope: "READ_CALCULATION",
        },
    ],
};
//# sourceMappingURL=mcp.js.map